module.exports = "pegasus/assets/blocks/header-5-theme4.png";